import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "balance",
    defaultRoutePath: "/finances/balance",
    menuItemScope: "finances",
    menuItemName: "balance",

    routes: [
        {
            path: "/finances/balance",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
